<script setup lang="ts">
import DefaultLayout from "@/components/DefaultLayout.vue";
</script>

<template>
  <DefaultLayout>
    <RouterView />
  </DefaultLayout>
</template>
